// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 0px 20px;
  width: 100%;
}
.wrapper .wrapper-articles {
  width: 100%;
  transition: flex-wrap 0.3s ease-in-out;
  position: relative;
}
.wrapper .wrapper-articles .item {
  width: 100%;
  margin-bottom: 12px;
  transition: max-width 0.3s ease-in-out;
}
.wrapper .button-show-more {
  width: 95%;
  margin-top: 20px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
  margin: 20px auto 5px;
}
.wrapper .button-show-more p {
  font-family: AppFontBold;
  color: var(--ion-color-secondary);
  font-size: 16px;
}
.wrapper .button-show-more .arrow-down {
  padding: 5px;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  rotate: 0deg;
  transition: rotate 0.3s ease-in-out;
}
.wrapper .button-show-more .arrow-down.rotate {
  rotate: 540deg;
}

.back-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  z-index: 99;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.back-icon ion-icon {
  fill: white;
  color: white;
}

.next-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  z-index: 99;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.next-icon ion-icon {
  fill: white;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-custom/article-option-group-custom.component.scss"],"names":[],"mappings":"AAGA;EACE,iBAAA;EACA,WAAA;AAFF;AAIE;EACE,WAAA;EACA,sCAAA;EACA,kBAAA;AAFJ;AAGI;EACE,WAAA;EACA,mBAAA;EACA,sCAAA;AADN;AAKE;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;EACA,qBAAA;AAHJ;AAKI;EACE,wBAAA;EACA,iCAAA;EACA,eAAA;AAHN;AAMI;EACE,YAAA;EACA,4CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mCAAA;AAJN;AAMM;EACE,cAAA;AAJR;;AAUA;EACE,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAPF;AASE;EACE,WAAA;EACA,YAAA;AAPJ;;AAWA;EACE,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AARF;AAUE;EACE,WAAA;EACA,YAAA;AARJ","sourcesContent":["@import \"../../../theme/mixins\";\n\n\n.wrapper {\n  padding: 0px 20px;\n  width: 100%;\n\n  .wrapper-articles {\n    width: 100%;\n    transition: flex-wrap 0.3s ease-in-out;\n    position: relative;\n    .item {\n      width: 100%;\n      margin-bottom: 12px;\n      transition: max-width 0.3s ease-in-out;\n    }\n  }\n\n  .button-show-more {\n    width: 95%;\n    margin-top: 20px;\n    padding: 5px 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--ion-color-secondary);\n    border-radius: 8px;\n    margin: 20px auto 5px;\n\n    p {\n      font-family: AppFontBold;\n      color: var(--ion-color-secondary);\n      font-size: 16px;\n    }\n\n    .arrow-down {\n      padding: 5px;\n      border: 1px solid var(--ion-color-secondary);\n      border-radius: 50%;\n      width: 25px;\n      height: 25px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-left: 5px;\n      rotate: 0deg;\n      transition: rotate 0.3s ease-in-out;\n\n      &.rotate {\n        rotate: 540deg;\n      }\n    }\n  }\n}\n\n.back-icon {\n  position: sticky;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  border-radius: 50%;\n  background: var(--ion-color-primary);\n  z-index: 99;\n  width: 30px;\n  height: 30px;\n  max-width: 30px;\n  max-height: 30px;\n\n  ion-icon {\n    fill: white;\n    color: white;\n  }\n}\n\n.next-icon {\n  position: sticky;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  border-radius: 50%;\n  background: var(--ion-color-primary);\n  z-index: 99;\n  width: 30px;\n  height: 30px;\n  max-width: 30px;\n  max-height: 30px;\n\n  ion-icon {\n    fill: white;\n    color: white;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
